import { Badge } from "react-bootstrap";
import { Case } from "../../../../models";
import { useEffect, useMemo, useState } from "react";
import { useAccountQuery, useTerritoryQuery } from "../../../../queries";
import { displayTextWithOverflow, getHoursSinceTOD, getTimeOfDeathBgColor } from "../../../../helper-functions";

interface ReferralSummaryProps {
    case: Case;
}

export function ReferralSummary({ case: _case }: Readonly<ReferralSummaryProps>) {
    const {
        listQuery: { data: territories },
    } = useTerritoryQuery();
    const { patientLastName, timeOfDeathUtc, overallStatus, referringOrganizationId, number, territoryId } =
        _case.referral ?? {};
    const {
        detailQuery: { data: account },
    } = useAccountQuery({ id: referringOrganizationId });
    const territory = territories?.find((t) => t.id === territoryId);

    const [hoursSinceTOD, setHoursSinceTOD] = useState<number | undefined>(getHoursSinceTOD(timeOfDeathUtc));

    useEffect(() => {
        const interval = setInterval(() => {
            setHoursSinceTOD(getHoursSinceTOD(timeOfDeathUtc));
        }, 60000);
        return () => clearInterval(interval);
    }, [timeOfDeathUtc]);

    const todBackground = useMemo(() => getTimeOfDeathBgColor(hoursSinceTOD), [hoursSinceTOD]);

    return (
        <div>
            <div className="d-flex justify-content-between">
                <div>
                    <span className="me-2">{number}</span>
                    <span className="fw-bold">{patientLastName}</span>
                </div>
                <div>{overallStatus || "New Referral"}</div>
            </div>
            <div className="d-flex justify-content-between">
                <div className="d-flex justify-content-start">
                    <div style={{ minWidth: "50px" }} className="text-dark">
                        <Badge bg={todBackground} className={todBackground == "warning" ? "text-dark" : ""}>
                            {hoursSinceTOD ?? "?"}
                        </Badge>
                    </div>
                    <div>{displayTextWithOverflow(account?.name, account?.name, 60)}</div>
                </div>
                <div className="ms-2">{territory?.label ?? territory?.name}</div>
            </div>
        </div>
    );
}
